<template>
  <div>
    <Head title="Manual Pengguna iLapor" />
    <span class="group flex items-center py-3 mb-6">
      <icon name="guidelines" class="mr-4 w-8 h-8 text-gray-700"/>
      <h1 class="text-3xl font-bold">User Manual</h1>
    </span> 

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Document Name</th>
            <th class="pb-4 pt-6 px-6 text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr  class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <span class="flex items-center px-6 py-4 focus:text-indigo-500 text-xl">
               User Manual for ESTAT System
              </span>
            </td>
            <td class="border-t text-center">
              <span class="flex items-center justify-center px-6 py-4">
                <a href="estat-user-manual.pdf" 
                  class="text-xl cursor-pointer items-center flex py-4 pr-2 focus:text-indigo-500" 
                  target="_blank">
                    <icon name="adobe" class="mr-2 w-4 h-4 fill-indigo-400"></icon>
                    Download Document
                </a>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
  </div>

</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import { ref } from "vue";
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,

  mounted(){ 
   
  },
}
</script>
